<script lang="ts">
	import type { HTMLAttributes } from 'svelte/elements';
	import NavItem from './navItem.svelte';
	import type { LegalPageItem } from './types';

	interface Props extends HTMLAttributes<HTMLDivElement> {
		pages: Array<LegalPageItem>;
	}

	let { pages }: Props = $props();
</script>

<nav class="text-[18px] font-semibold leading-[19.8px] max-lg:hidden">
	<ul class="flex flex-col items-start gap-y-2">
		{#each pages as { display_name, page }}
			<NavItem link={page}>{display_name}</NavItem>
		{/each}
	</ul>
</nav>
